import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const EditIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M19.1719 2C18.4481 2 17.7244 2.27562 17.1719 2.82812L16 4L20 8L21.1719 6.82812C22.2759 5.72412 22.2759 3.93313 21.1719 2.82812C20.6194 2.27562 19.8956 2 19.1719 2ZM14.5 5.5L3 17V21H7L18.5 9.5L14.5 5.5Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

EditIcon.propTypes = {
  sx: PropTypes.object,
};

export default EditIcon;
